const config = {
  baseApi: process.env.REACT_APP_BASE_URL,
  baseApiDropDown: process.env.REACT_APP_BASE_URL_DROPDOWN,
  baseApiDropDownFootball: process.env.REACT_APP_BASE_URL_FOOTBALL_DROPDOWN,
};

export default config;
